import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class NavBarItem extends Component {
	constructor(props) {
  		super(props);
  		this.state = {
  		};
	}
	
	handleClickEvent() {
		this.props.handleClickEvent();
	}
      
	render() {
    	return (
            <div>
                <li className="nav-item whiteSpaceNoWrap">
					<Link to={"/" + this.props.url} className="nav-link" onClick={this.handleClickEvent.bind(this)}>{this.props.name.toUpperCase()} {(this.props.badge) ? <span className="badge badge-danger">{this.props.badge}</span> : ""} </Link> 
                </li>

            </div>
    	);
  	}
}

export default NavBarItem;


// WEBPACK FOOTER //
// ./src/components/navbar.item.component.js